<div class="p-3">
    <h3 class="mb-0 fw-bolder">Select Template</h3>
    <p class="mb-0 text-muted">Select template for quick reply.</p>
    <hr/>
    <div class="list-group">    
        <li class="list-group-item list-group-item-action" *ngFor="let list of lists" (click)="select(list)" [innerHTML]="html(list.template)" [class.active]="template && template.uuid == list.uuid"></li>
    </div>
    <div class="mt-3 d-flex flex-row gap-2">
        <button class="btn btn-primary flex-fill" (click)="sendTemplate()" [disabled]="!template">Send Template</button>
        <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
</div>